<template>

  <div :class="[{'upcoming-events': true,'bet-options': sport === 'All Sports'}]">
      <div class="btn-container">
        <div class="left-buttons">
          <button :hidden="sport =='All Sports'" :class="{'active-button': showLiveEvents, 'inactive-button': !showLiveEvents}" @click="toggleLive()">Live</button>
          <button :hidden="sport =='All Sports'" :class="{'active-button': !showLiveEvents, 'inactive-button': showLiveEvents}" @click="toggleUpcoming()">Upcoming</button>
        </div>

          <button v-if="showLiveEvents" class="expand-button" @click="toggleValue()">{{ getButtonText() }}
          <img :src="getChevronPath()" class="chevron" :class="{'rotate-chevron': isExpanded}" alt="chevron_svg"/>
          </button>

      </div>
    <v-expansion-panel v-if="showLiveEvents" v-model="tournamentPanel" expand dark class="tournament-panel">
      <v-expansion-panel-content
        class="purple darken-4"
        v-for="item in tournaments"
        v-model="tournIndex[item.tournament]"
        :key="item.id"
      >
        <div slot="header" class="tournament-title">
          <span>
            <img
              :src="getSportIconPath(sport === 'All Sports' ? item.sport : sport)"
              class="tournament-title-icon" alt=""/></span
          ><span class="tournament-title-header">{{ item.tournament }}</span>
        </div>
        <v-card>
          <v-card-text class="grey darken-3">
            <v-expansion-panel class="mb-0 full-white-border">
              <v-expansion-panel-content
                accordion
                class="event-card"
                v-for="event in item.events"
                v-model="evbtIndex[event.fixtureId]"
                :key="event.fixtureId"
                v-on:click.native="setEventFixtureId($event, event.fixtureId, event)"
              >
                <template v-slot:actions>
                  <v-icon display="none"></v-icon>
                </template>
                <div slot="header" class="white-color event-header">
                  <div class="tournament-name"></div>
                  <div class="game-header-title">
                    <div v-if="event" class="event-match-summary">
                      <MatchSummary
                        :matchSummaryData="event"
                        :connection="connection"
                        :sport="sport === 'All Sports' ? item.sport : sport"
                        :eventId="event.fixtureId"
                        :eventName="event.eventName"
                      ></MatchSummary>
                    </div>
                  </div>
                  <MatchWinner
                    :connection="connection"
                    :sport="sport === 'All Sports' ? item.sport : sport"
                    :tournament="item.tournament"
                    :eventId="event.fixtureId"
                    :eventName="event.eventName"
                    :eventTime="event.startTime"
                    :events="events"
                    :expanded="tournIndex[item.tournament]"
                  ></MatchWinner>

                  <div class="more-markets-container">
                    <div>
                      <span class="more-markets">more markets</span>
                      <span>
                        <v-icon small>chevron_right</v-icon>
                      </span>
                    </div>
                  </div>
                </div>
                <v-card class="grey darken-4">
                  <v-card-text>
                    <!-- Statscore Container -->
                    <div class="tracker-container" v-if="isMobile()">
                      <v-btn
                        v-if="showTrackerBtn"
                        v-on:click="showStatscorePlayer()"
                        class="btn-submit-header"
                        style="
                          width: 42%;
                          display: inline-block;
                          text-align: center;
                        "
                        >Match Tracker</v-btn
                      >
                      <v-btn
                        v-if="showStreamBtn"
                        v-on:click="showImgPlayer()"
                        class="btn-submit-header"
                        style="
                          width: 42%;
                          display: inline-block;
                          text-align: center;
                        "
                        >Live Stream</v-btn
                      >
                    </div>
                    <div>
                      <Statscore
                        v-if="isMobile() && showStatscore"
                        :eventObject="event"
                      ></Statscore>
                      <Widget
                        v-if="isMobile() && showImg"
                        :eventObject="event"
                      ></Widget>
                    </div>
                    <EventBetTypes
                      :statscoreId="statscoreId"
                      :connection="connection"
                      :state="event.gameState"
                      :sport="sport === 'All Sports' ? item.sport : sport"
                      :tournament="item.tournament"
                      :eventId="event.fixtureId"
                      :eventName="event.eventName"
                      :eventTime="event.startTime"
                      :betTypeGroups="sport === 'All Sports' ? betTypes[item.sport] : betTypes[sport]"
                      :expanded="evbtIndex[event.fixtureId]"
                    ></EventBetTypes>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <UpcomingEvents :hidden="!sport || sport =='All Sports' || showLiveEvents" :connection="connection" :sport="sport" ></UpcomingEvents>
  </div>
</template>

<script>
import EventBetTypesApi from '../api/eventBetTypes';
import EventBetTypes from "./EventBetTypes.vue";
import TournamentsEventsApi from "../api/tournamentsEvents";
import SportsApi from '../api/sportFixtures';
import { HubConnection } from "@aspnet/signalr";
import MatchWinner from "./MatchWinner.vue";
import UpcomingEvents from "./UpcomingEvents.vue";
import MatchSummary from "./MatchSummary.vue";
import Scoreboard from "./Scoreboard.vue";
import Statscore from "./Statscore.vue";
import Widget from "./Widget.vue";
import * as CONFIG from "../config";
import StreamAPI from "../api/streaming";
import store from "../store";

export default {
  name: "BetOptions",
  components: {
    EventBetTypes,
    MatchWinner,
    UpcomingEvents,
    MatchSummary,
    Scoreboard,
    Statscore,
    Widget,
  },
  data() {
    return {
      showStatscore: true,
      showImg: false,
      showTrackerBtn: false,
      showStreamBtn: false,
      imgPoster: "",
      imgStreamLink: "",
      tournaments: [],
      tournamentPanel: [],
      evbtIndex: {},
      currentFixtureIds: [],
      betTypes: {},
      tournIndex: {},
      events: [],
      sportCount: {},
      sportsSet :{},
      value:0,
      buttonExpanded: true,
      showLiveEvents: true,
      SportUpcomingEvents: null
    };
  },
  props: {
    sport: String,
    connection: HubConnection,
    statscoreId: Number,
    eventObject: Object,
  },
  mounted (){
    this.updateEventCounts();
  },
  watch: {
    sport: function (newSport, oldSport) {
      if (this.sport != "" && oldSport != newSport) {
        for (var i = 0; i < this.currentFixtureIds.length; i++) {
          this.connection.invoke(
            "UnSubscribe",
            this.currentFixtureIds[i] + "eventBetType"
          );
          this.currentFixtureIds.pop();
        }
        if (newSport !== "All Sports" && this.showLiveEvents)
        {
              this.getEventBetTypes(this.sport);
        }
        this.getTournamentsEvents(this.sport);
      }
    },
    evbtIndex: function () {},
    ueIndex: function () {},
    tournIndex: function () {},
    events: function () {},
  },
  methods: {
    toggleValue() {
          this.buttonExpanded = !this.buttonExpanded;
          const expanded = this.buttonExpanded;
          this.tournamentPanel = this.tournamentPanel.map(() => expanded);
    },
    getButtonText() {
          return this.buttonExpanded ? "Collapse All" : "Expand All";
    },
    toggleLive(){
        this.showLiveEvents =true;
        this.SportUpcomingEvents='';
        this.tournamentPanel = new Array(this.tournaments.length).fill(true);
    },
    toggleUpcoming() {
      this.showLiveEvents = false;
      this.SportUpcomingEvents = this.sport;
    },
    updateEventCounts() {
      setInterval(() => {
          SportsApi.getEventCounts().then((data) => {
              this.sportCount = {};
              var StreamingCount= 0 ;
              data.responseObject.forEach(item => {
                if(item.sport=="StreamingEvents"){
                  StreamingCount=item.count;
                }
                    this.sportCount[item.sport] = item.count;
              })
              var AllSportCounter =  this.sportCount["All Sports"];
              this.sportCount["All Sports"] = AllSportCounter - StreamingCount;
              this.$emit("sportCount", this.sportCount);
          });
      }, 30000);
    },
    getEventBetTypes(sport) {
      if(this.showLiveEvents)
      {
          EventBetTypesApi.getEventBetTypes(sport)
          .then(data => {
            this.betTypes[sport] = data.responseObject;
          });
      }
    },
    showImgPlayer() {
      this.showImg = true;
      this.showStatscore = false;
    },
    showStatscorePlayer() {
      this.showStatscore = true;
      this.showImg = false;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    getSportIconPath(sportName) {
      if (sportName) {
        if (this.sport) {
          const svgName = sportName.replace(/\s/g, '-').toLowerCase();

            if(CONFIG.DARK_MODE)
            {
                return require(`../assets/img/icons/${svgName}-dark.svg`);
            }else
            {
                return require(`../assets/img/icons/${svgName}.svg`);
            }
        }

      }
    },
    getChevronPath()
    {
          return require(`../assets/img/icons/chevron.svg`);
    },
    getTournamentsEvents(sport) {
      TournamentsEventsApi.getTournamentsEvents(sport).then((data) => {
            let response = data.responseObject || [];
            this.tournaments = [];
            this.buttonExpanded = true;
            if (sport === "All Sports"){
              this.showLiveEvents=true;
              response.forEach(item => {
                    if (item.tournaments){
                        item.tournaments.forEach(tournament => {
                            tournament.sport = item.sport; // Adding sport to each tournament for icons and bet type groups
                            this.tournaments.push(tournament);
                        });
                    }
                });

              const sportsSet = new Set(response.filter(tournament => tournament.sport !== 'All Sports').map(tournament => tournament.sport));
              sportsSet.forEach(sportItem => {
                  this.getEventBetTypes(sportItem);
              });
            }
            else {
              this.tournaments = response || [];
            }

            this.tournamentPanel = new Array(this.tournaments.length).fill(true);

            SportsApi.getEventCounts().then((data) => {
                    this.sportCount = {};
                    var StreamingCount =0;
                    data.responseObject.forEach(item => {
                      if(item.sport=="StreamingEvents"){
                  StreamingCount=item.count;
                }
                    this.sportCount[item.sport] = item.count;
              })
              var AllSportCounter =  this.sportCount["All Sports"];
              this.sportCount["All Sports"] = AllSportCounter - StreamingCount;
                    this.$emit("sportCount", this.sportCount);
            });

        }).catch(error => {
            console.error("Error fetching tournaments events", error);
        });

    },
    updateFixture(updatedFixture) {
      let tournamentIndex = this.tournaments.findIndex(
        (t) => t.tournament === updatedFixture.Tournament
      );
      if (tournamentIndex !== -1) {
        let i = this.tournaments[tournamentIndex].events.findIndex(
          (t) => t.fixtureId === updatedFixture.FixtureID
        );
        if (i !== -1) {
          //found
          //update fixture name, startTime, etc
          if (
            this.tournaments[tournamentIndex].events[i].startTime !==
            updatedFixture.StartTime
          )
            this.tournaments[tournamentIndex].events[i].startTime =
              updatedFixture.StartTime;
          if (
            this.tournaments[tournamentIndex].events[i].eventName !==
            updatedFixture.EventName
          )
            this.tournaments[tournamentIndex].events[i].eventName =
              updatedFixture.EventName;
          if (
            this.tournaments[tournamentIndex].events[i].status !==
            updatedFixture.Status
          )
            this.tournaments[tournamentIndex].events[i].status =
              updatedFixture.Status;
          if (
            this.tournaments[tournamentIndex].events[i].gameState !==
              updatedFixture.GameState &&
            updatedFixture.GameState !== ""
          ) {
            this.tournaments[tournamentIndex].events[i].gameState =
              updatedFixture.GameState;
          }
        } else {
          //Add the new event
          this.tournaments[tournamentIndex].events.push({
            fixtureId: updatedFixture.FixtureID,
            eventName: updatedFixture.EventName,
            startTime: updatedFixture.StartTime,
          });
        }
      } else {
        //Add the new tournament
        this.getTournamentsEvents(this.sport);
      }
    },
    mergeFixture(api, signalR) {
      let temp = api.map((s) => s.startTime);
      for (let item in signalR) {
        let value = signalR[item].Sport;
        if (temp.indexOf(value) === -1) api.push({ sport: value });
      }
      return api;
    },
    setEventFixtureId(event, fixtureId, eventData) {
      const isStatscoreClick = this.isStatscoreClick(event.target);
      if (!isStatscoreClick) {
        fixtureId = fixtureId.toString();
        if (this.evbtIndex.hasOwnProperty(fixtureId)) {
          this.getMappedEventData(fixtureId);

          this.$emit("childToParent", eventData);
          this.connection.invoke("Subscribe", fixtureId + "eventBetType");
          this.currentFixtureIds.push(fixtureId);
          const configurationId = CONFIG.STATSCORE_CONFIG_ID;
          //Check if div is Empty AND if the ID being generated doesnt exist (WebView only)
          if (
            document.getElementById("statscoreHolder") &&
            document.getElementById("statscoreHolder").innerHTML === "" &&
            !document.getElementById("sp_" + eventData.fixtureId)
          ) {
            if (CONFIG.STATSCORE_WIDGET) {

              if (eventData.statscoreIsMapped) {
                var element = document.createElement("div");
                element.id = "sp_" + eventData.fixtureId;
                document.getElementById("statscoreHolder").appendChild(element);
                if (this.isMobile()) {
                  document.getElementById('sp_' + eventData.fixtureId).innerHTML = "";
                  const inputData =
                  {
                      eventId: 'm:' + eventData.statscoreEventID,
                      lang: 'en',
                      timezone: -120
                  };
                  const options = {};
                  const widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);
                }
                else {
                  const inputData =
                  {
                      eventId: 'm:' + eventData.statscoreEventID,
                      lang: 'en',
                      timezone: -120
                  };
                  const options = {};
                  const widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);
                }
              }
            }
          }
          else if (document.getElementById("sp_" + eventData.fixtureId)) {
            var element = document.getElementById("sp_" + eventData.fixtureId);
            if (CONFIG.STATSCORE_WIDGET) {
              var element = document.getElementById("sp_" + eventData.fixtureId);
              if (element.firstChild && element.firstChild.className && !element.firstChild.className.includes('STATSCOREWidget')) {
                if (eventData.fixtureId !== fixtureId && this.isMobile()) {
                  document.getElementById("sp_" + eventData.fixtureId).innerHTML = "";
                }

                if (this.isMobile()) {
                  document.getElementById("sp_" + eventData.fixtureId).innerHTML = "";
                  const inputData =
                  {
                      eventId: 'm:' + eventData.statscoreEventID,
                      lang: 'en',
                      timezone: -120
                  };
                  const options = {};
                  const widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);
                }
                else if (eventData.fixtureId !== fixtureId) {
                    const inputData =
                    {
                        eventId: 'm:' + eventData.statscoreEventID,
                        lang: 'en',
                        timezone: -120
                    };
                    const options = {};
                    const widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);
                }
              }
            }
          }
        } else if (!this.evbtIndex[fixtureId] && fixtureId) {
          if (
            document.getElementById("sp_" + eventData.fixtureId) &&
            this.isMobile()
          ) {
            document.getElementById("sp_" + eventData.fixtureId).innerHTML = "";
          }
          this.connection.invoke("UnSubscribe", fixtureId + "eventBetType");
        }
      }
    },
    isStatscoreClick(target){
      return target.className.includes('STATSCOREWidget');
    },
    getMappedEventData(fixtureId) {
      StreamAPI.getStreamingEvent(fixtureId)
        .then((data) => {
          if (data.responseObject && store.getters.punterId > 0) {
            this.showStreamBtn = true;
            this.showTrackerBtn = true;
          } else {
            this.showStreamBtn = false;
            this.showTrackerBtn = false;
            this.showStatscore = true;
          }
        })
        .catch((err) => console.log(err));
    },
  },
  computed: {
    isExpanded() {
        return this.buttonExpanded ? false : true;
    }
  },
  filters: {
    '24HourFormat': function (value) {
      if (!value) return '';

      const options = {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      };

      const date = new Date(value);
      return date.toLocaleString('en-US', options).replace(',', '');
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.bet-options {
  margin-bottom: 200px;
}

.expand-button {
  display: inline-flex;
  align-items: center;
  border: 1px solid #8066E9;
  border-radius: 0.5rem;
  outline: none;
  transition: all 0.25s ease-in-out;
  font-family: "Poppins";
  text-transform: capitalize;
  font-size: 0.75rem;
  margin: 0 0 0.5rem;
  background: rgb(255, 255, 255);
  color: #8064E6;
  padding: 0.5rem;
  cursor: pointer;
  margin-left: auto;
}

.active-button {
  align-items: center;
  border: 1px solid #8064E6;
  border-radius: 0.5rem;
  outline: none;
  transition: all 0.25s ease-in-out;
  font-family: "Poppins";
  text-transform: uppercase;
  font: normal normal bold 12px/20px Poppins;
  margin: 0 0 0.5rem;
  background: #8064E6;
  color: #fff;
  padding: 0.5rem;
  cursor: pointer;
  width: 6rem;
}

.inactive-button {
  align-items: center;
  border-radius: 0.5rem;
  outline: none;
  transition: all 0.25s ease-in-out;
  font-family: "Poppins";
  text-transform: uppercase;
  font: normal normal  12px/20px Poppins;
  margin: 0 0 0.5rem;
  background: #fff;
  color: #8064E6;
  padding: 0.5rem;
  cursor: pointer;
  width: 6rem;
}

.left-buttons {
  display: flex;
  gap: 5px;
  margin-right: auto;
}

.expand-button img {
  margin-left: 0.5rem;
  transition: transform 0.25s ease-in-out;
}

.rotate-chevron {
  transform: rotate(-180deg);
}

.btn-container {
  display: flex;
  width: 100% !important;
  background-color: #f4f6fd;
  padding:2px !important;
  margin: 0px !important;
  align-content: center;
  justify-content: space-between;
  justify-items: center;
  min-height: 43px;
}

tr thead th {
  color: #8064E6 !important;
}

@media (max-width: 768px) {
  .btn-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .left-buttons {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .active-button, .inactive-button {
    flex: 1;
    width: auto;
  }

  .expand-button {
    align-self: flex-end;
    width: auto;
  }
}
.video-js .vjs-tech {
  width: 100vw;
}
.event-match-summary {
  margin-top: 1px;
  margin-bottom: 2px;
  font-size: 10px;
  color: #000;
}

.event-name {
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}

.event-date {
  margin-top: 1px;
  margin-bottom: 2px;
  font-size: 10px;
  color: grey;
}

img.live-icon {
  display: inline;
  text-align: left;
  position: absolute;
  /*left: 213px;*/
  background-color: #201927;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 6px;
  padding-right: 6px;
  top: 6px;
}

.tournament-title-icon {
  width: 18px;
  margin-right: 5px;
  vertical-align: sub;
  color: #4f2e7b;
}

.white-color {
  color: #fff;
}

.tournament-header {
  background-color: #004369;
}


.tournament-title {
font: normal normal normal 14px/20px Poppins;
padding-left: 10px;
color: #8064E7;
}

.theme--dark.v-expansion-panel .v-expansion-panel__container {
  background-color: #fff !important;
  margin-bottom: 10px;
}

.sub-header {
  color: gold;
  display: block;
}

.purple.darken-3,
.purple.darken-2 {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-color: #E6EDFF !important;
  font-weight: 600;
}

.purple.darken-4 {
  background-color: #000000;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border:#E6EDFF 2px solid !important;
  overflow: hidden;
}

.game-header-title {
  padding-left: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: -1px;
  border-bottom: 0px solid #000;
  width: 15%;
}

.game-header-title span {
  background-color: #382058;
  display: inline;
  padding-top: 20px;
  margin-top: -15px;
  text-align: left;
  float: left;
  padding-top: 6px;
  margin-top: -8px;
  margin-right: 35px;
  padding-left: 15px;
  padding-right: 10px;
  padding-bottom: 4px;
  line-height: 25px;
  min-width: 178px;
  position: absolute;
  left: 0px;
  font-size: 9px;
  max-width: 20%;
}

.word-wrap {
  overflow-wrap: break-word;
}

.v-expansion-panel.mb-0.theme--dark > li {
  margin: 0px !important;
}

.upcomingEvents {
  padding-top: 20px;
  background-color: #0a0a0a !important;
}

.upcomingEventsNoSport {
  padding-top: 0px;
}


.v-card__text {
  padding: 0px !important;
  width: 100%;
  border-top: 0px solid #000;
  border-bottom: 0px solid #000;
}

.full-white-border {
  border: 0px solid #fff !important;
}

.disableText.marketName {
  padding-left: 10px;
}

@media (max-width: 480px) {
  img.live-icon {
    /* left: 198px; */
  }
}

@media (max-width: 320px) {
  .reduce-event-name-size {
    font-size: 9px;
    word-break: break-word;
    overflow-wrap: break-word;
  }
}

.event-header {
  background-color: #fff;
  display: flex;
  min-height: 60px;
}

@media (max-width: 960px) {
  .tournament-panel {
    margin-bottom: 150px;
  }
}

.event-card {
  border-top: 1px solid #eeeeee !important;
}

.event-card:first-child {
  border-top: 1px solid #eeeeee !important;
}

.more-markets {
  font-size:12px;
  color: #8064E6;
  font: normal normal normal 12px/18px Poppins;
  opacity: 1;
}

.more-markets-container {
  display: flex;
  position: relative;
  right: 20px;
  width: 15%;
  justify-content: flex-end;
  align-items: center;
  margin-left: auto;
}

.more-markets-container .v-icon {
  color: #8064E6;
}

.tournament-name {
  padding-top: 8px;
  padding-left: 10px;
  color: #11142D;
  opacity: 1;
  width: 20%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}



@media (max-width: 960px) {
  .tournament-name {
      display: none;
  }

  .more-markets-container {
    display: flex;
    right: 0;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    bottom: 8px;
  }

  .game-header-title {
    padding-left: 10px;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-top: -1px;
    border-bottom: 0px solid #000;
    width: 60%;
    margin-bottom: 20px;
  }
  .tournament-title-header {
    padding-right: 22px;
  }

  .tournament-title {
    width: 90%;
    display: contents;
  }

  .tournament-title-icon{
    margin-left: 5px;
  }
}
.progress-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* Ensure the progress spinner takes up full height */
}

.v-datatable__actions__select {
  display: none !important;
}
.odd {
  color: gold;
}
.bold {
  font-weight: 700;
  padding-right: 10px;
}
table {
  width: 100%;
  color: #FFFFFF;
  overflow-wrap: break-word;
}
th {
  color: #fff;
  border-bottom: 2px solid #696969;
}
th, td {
  text-align: left;
  padding: 4px;
  font-size: 14px !important;
  padding-bottom: 10px !important;
  font-weight: 300;
}
.tournament-title.upcoming {
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 10px;
  background-color: #4f2e7b;
  border-color: #4f2e7b !important;
}
.grey.darken-2 {
  background-color: #4f2e7b !important;
}
@media only screen and (max-width: 768px), (min-device-width: 768px) and (max-device-width: 1024px) {
  th, td {
    text-align: left;
    font-size: 11px !important;
    font-weight: 300;
  }
  .active-button {
    background: transparent linear-gradient(180deg, #844BC5 0%, #7D77FF 100%) 0% 0% no-repeat padding-box;
  }
}
.upcoming-events {
  background-color: #f4f6fd;
}
</style>

